import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/logo.png";
import "../../components/css/NotificationAlert.css";
import { setupOnMessageListener } from "../../notification";

const NotificationAlert = () => {
  const [notification, setNotification] = useState(null);

  const handleNewNotification = (notification) => {
    if (notification) {
      setNotification({
        title: notification.title,
        body: notification.body,
        image: notification.image || Logo,
      });

      setTimeout(() => setNotification(null), 3000);
    }
  };

  useEffect(() => {
    const setupListener = async () => {
      try {
        setupOnMessageListener(handleNewNotification);
      } catch (error) {
        console.error("Error setting up notification listener:", error);
      }
    };
    
    // Set up listener immediately
    setupListener();
    
    // Retry after a delay to ensure Firebase is ready
    const retryTimeout = setTimeout(setupListener, 3000);
    
    return () => clearTimeout(retryTimeout);
  }, []);

  return (
    notification && (
      <div className="notification-alert-overlay">
        <div className="notification-alert-box">
          <img
            src={notification.image}
            alt="Notification"
            className="notification-alert-image"
          />

          <div className="notification-alert-header">
            <strong className="notification-alert-title">
              {notification.title}
            </strong>
            <p className="notification-alert-body">{notification.body}</p>
          </div>
          <button
            onClick={() => setNotification(null)}
            className="notification-alert-close-button"
          >
            x
          </button>
        </div>
      </div>
    )
  );
};

export default NotificationAlert;
